/**
 * useIsAdmin — Fetches /api/me once and caches the admin flag for the session.
 * Returns { isAdmin, loading } so components can conditionally render admin features.
 * In demo mode, always returns isAdmin: false.
 */

import { useState, useEffect } from "react";
import { getUserInfo, isDemoMode } from "../utils/PowerBIApiCall";

let cachedIsAdmin: boolean | null = null;

export function useIsAdmin(): { isAdmin: boolean; loading: boolean } {
  const demo = isDemoMode();
  const [isAdmin, setIsAdmin] = useState(
    demo ? true : (cachedIsAdmin ?? false),
  );
  const [loading, setLoading] = useState(cachedIsAdmin === null && !demo);

  useEffect(() => {
    if (demo || cachedIsAdmin !== null) return;

    getUserInfo()
      .then((info) => {
        cachedIsAdmin = info.isAdmin;
        setIsAdmin(info.isAdmin);
      })
      .catch(() => {
        cachedIsAdmin = false;
        setIsAdmin(false);
      })
      .finally(() => setLoading(false));
  }, []);

  return { isAdmin, loading };
}
